<div class="checkins-container">
  <!-- Header -->
  <div class="header">
    <div class="header-content">
      <div>
        <h1><i class="fas fa-camera"></i> Selfie Check-ins</h1>
        <p>Monitor daily agent uniform and tag verification</p>
      </div>
      <button class="refresh-btn" (click)="loadCheckIns()" [disabled]="isLoading">
        <i class="fas fa-sync-alt" [class.fa-spin]="isLoading"></i>
        Refresh
      </button>
    </div>
  </div>

  <!-- Filters -->
  <div class="filters-container">
    <div class="filter-group">
      <label for="dateFilter">Date</label>
      <input
        id="dateFilter"
        type="date"
        [(ngModel)]="selectedDate"
        (ngModelChange)="onFilterChange()"
        class="filter-input"
      />
    </div>
    <div class="filter-group">
      <label for="zoneFilter">Zone</label>
      <select
        id="zoneFilter"
        [(ngModel)]="selectedZoneId"
        (ngModelChange)="onFilterChange()"
        class="filter-select"
      >
        <option value="">All Zones</option>
        <option *ngFor="let zone of zones" [value]="zone.id">{{ zone.name }}</option>
      </select>
    </div>
  </div>

  <!-- Summary banner -->
  <div class="summary-banner" *ngIf="!isLoading && checkins.length > 0">
    <div class="summary-stat checked-in">
      <span class="stat-number">{{ checkedInCount }}</span>
      <span class="stat-label">Checked In</span>
    </div>
    <div class="summary-divider"></div>
    <div class="summary-stat not-checked-in">
      <span class="stat-number">{{ checkins.length - checkedInCount }}</span>
      <span class="stat-label">Not Checked In</span>
    </div>
    <div class="summary-divider"></div>
    <div class="summary-stat total">
      <span class="stat-number">{{ checkins.length }}</span>
      <span class="stat-label">Total Agents</span>
    </div>
  </div>

  <!-- Loading -->
  <div class="loading" *ngIf="isLoading">
    <i class="fas fa-spinner fa-spin"></i>
    <p>Loading check-in data...</p>
  </div>

  <!-- Table -->
  <div class="table-container" *ngIf="!isLoading && checkins.length > 0">
    <table class="checkins-table">
      <thead>
        <tr>
          <th>Status</th>
          <th>Agent ID</th>
          <th>Name</th>
          <th>Phone</th>
          <th>Zones</th>
          <th>Checked In At</th>
          <th>Selfie</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let checkin of checkins" [class.checked-in-row]="checkin.hasCheckedIn">
          <td data-label="Status">
            <span class="status-badge" [class.checked]="checkin.hasCheckedIn" [class.not-checked]="!checkin.hasCheckedIn">
              <i class="fas" [class.fa-check-circle]="checkin.hasCheckedIn" [class.fa-times-circle]="!checkin.hasCheckedIn"></i>
              {{ checkin.hasCheckedIn ? 'Checked In' : 'Missing' }}
            </span>
          </td>
          <td data-label="Agent ID" class="agent-id">{{ checkin.agentId }}</td>
          <td data-label="Name" class="agent-name">{{ checkin.name }}</td>
          <td data-label="Phone">{{ checkin.phoneNumber }}</td>
          <td data-label="Zones" class="zones-cell">{{ getZoneNames(checkin.zones) }}</td>
          <td data-label="Checked In At" class="time-cell">
            <span *ngIf="checkin.checkedInAt">
              {{ checkin.checkedInAt | date: 'hh:mm a' }}
            </span>
            <span *ngIf="!checkin.checkedInAt" class="na">—</span>
          </td>
          <td data-label="Selfie">
            <button
              *ngIf="checkin.hasCheckedIn"
              class="view-selfie-btn"
              (click)="viewSelfie(checkin)"
              [disabled]="loadingSelfieFor === checkin.agentId"
              title="View Selfie"
            >
              <i class="fas" [class.fa-image]="loadingSelfieFor !== checkin.agentId" [class.fa-spinner]="loadingSelfieFor === checkin.agentId" [class.fa-spin]="loadingSelfieFor === checkin.agentId"></i>
              View
            </button>
            <button
              *ngIf="!checkin.hasCheckedIn"
              class="override-selfie-btn"
              (click)="overrideCheckin(checkin)"
              title="Manually Approve Check-in"
            >
              <i class="fas fa-check-circle"></i>
              Approve
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Empty state -->
  <div class="empty-state" *ngIf="!isLoading && checkins.length === 0">
    <i class="fas fa-camera-slash"></i>
    <p>No active agents found for the selected filters.</p>
  </div>

  <!-- Selfie lightbox -->
  <div class="lightbox-overlay" *ngIf="selfieUrl || selfieError || loadingSelfieFor" (click)="closeSelfie()">
    <div class="lightbox" (click)="$event.stopPropagation()">
      <div class="lightbox-header">
        <span>{{ selfieAgentName }}</span>
        <button class="close-btn" (click)="closeSelfie()"><i class="fas fa-times"></i></button>
      </div>
      <div class="lightbox-body">
        <img *ngIf="selfieUrl" [src]="selfieUrl" alt="Agent selfie" class="selfie-image" />
        <div class="selfie-loading" *ngIf="loadingSelfieFor && !selfieUrl && !selfieError">
          <i class="fas fa-spinner fa-spin fa-2x"></i>
          <p>Loading selfie...</p>
        </div>
        <div class="selfie-error" *ngIf="selfieError">
          <i class="fas fa-exclamation-triangle fa-2x"></i>
          <p>{{ selfieError }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Notification toast -->
  <div class="notification-toast" [class]="notification.type" [class.show]="notification.show">
    <div class="notification-content">
      <i class="fas"
         [class.fa-check-circle]="notification.type === 'success'"
         [class.fa-exclamation-circle]="notification.type === 'error'"
         [class.fa-info-circle]="notification.type === 'info'"></i>
      <span>{{ notification.message }}</span>
    </div>
    <button class="notification-close" (click)="closeNotification()">
      <i class="fas fa-times"></i>
    </button>
  </div>
</div>
